import React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

const ClientUser = () => {
  const context = useOutletContext();
  return (
    <Outlet context={context}/>
  )
}

export default ClientUser